export const useScrollStore = defineStore('scroll', {
  state: () => ({
    scrollTo: '',
  }),

  actions: {
    setScroll(product: string) {
      this.scrollTo = product;
    },
  },
});
